import styled from '@app/styled';
import { color } from '@app/theme';

export const Container = styled.div`
    padding-top: 3px;
    padding-left: 18px;
    position: relative;
`;

export const Lines = styled.div`
    width: 13px;
    height: 10px;
    border-style: solid;
    border-color: ${color('border.default')};
    border-width: 0;
    border-bottom-width: 1px;
    border-left-width: 1px;
    position: absolute;
    top: 0;
    left: 0;
`;
